import {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {CpcAd as CpcAdBlock} from '@/modules/common/components/CpcAd';
import {useDestination} from '@/modules/common/hooks/useDestination';
import {useSearchParams} from '@/modules/common/hooks/useSearchParams';

type Props = {
  id: 'cpcAdHotelsFooter' | 'cpcAdHotelsSidebar';
  visuallyHidden?: boolean;
};

export const CpcAd = memo(function CpcAd({id, visuallyHidden}: Props) {
  const {t} = useTranslation('general');
  const [{travelType}] = useSearchParams();
  const destination = useDestination();

  const query = destination.keyword?.keyword
    ? [destination.keyword.keyword, t(`travelType.${travelType}`)].join(';')
    : '';

  return (
    <CpcAdBlock
      id={id}
      query={query}
      style={{
        display: visuallyHidden ? 'none' : undefined,
        height: {
          cpcAdHotelsFooter: '300px',
          cpcAdHotelsSidebar: '600px',
        }[id],
      }}
    />
  );
});
